import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { FileTypes } from 'src/app/layouts/full/shared/Enums';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';

@Component({
  selector: 'app-three-d-file-classificator',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './three-d-file-classificator.component.html',
  styleUrl: './three-d-file-classificator.component.scss'
})
export class ThreeDFileClassificatorComponent {
  @Input() filesToClassify: { name: string, extension: string }[] = [];
  @Output() closeModalWhenSubmit = new EventEmitter<void>();
  @Output() closeModalWhenCancel = new EventEmitter<void>();
  @Output() formDataReady = new EventEmitter<void>();

  filesToClassifyForm: FormGroup
  filesFormData: any = []
  currentUpload: any = [];
  currentStep: number = 0;
  files: any = []
  fileTypes = [
    { name: 'SCAN_TYPES.PLANTAR_SURFACE', value: 'plantarSurface' },
    { name: 'SCAN_TYPES.FOAM', value: 'foam' },
    { name: 'SCAN_TYPES.FOOT', value: 'foot' },
    { name: 'SCAN_TYPES.LEG', value: 'leg' },
    { name: 'SCAN_TYPES.TORSO', value: 'torso' },
    { name: 'SCAN_TYPES.FACE', value: 'face' }
  ]

  constructor(private fb: FormBuilder) {
    // Create form from files received
    this.filesToClassifyForm = this.fb.group({
      files: this.fb.array([])
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filesToClassify']) {
      try {
        if (this.filesToClassify && this.filesToClassify.length > 0) {
          this.filesToClassifyForm.setControl('files', this.buildForm());
        } else {
          this.filesToClassifyForm.setControl('files', this.fb.array([]));
        }
      } catch (error) {
        console.error("Error building form: ", error);
      }
    }
  }

  buildForm(): FormArray {
    const forms = this.fb.array([] as FormGroup[]);

    // For each file we receive, new form is created
    this.filesToClassify.forEach((file) => {
      const formGroup = this.fb.group({
        name: [file.name, [Validators.required]],
        extension: [file.extension, [Validators.required]],
        type: ['', [Validators.required]],
        side: ['']
      });

      forms.push(formGroup);
    });

    return forms;
  }

  requiresLeftAndRight(i: number): boolean {
    const formArray = this.filesToClassifyForm.get('files') as FormArray;

    if (i >= 0 && i < formArray.length) {
      const formGroup = formArray.at(i) as FormGroup;
      const type = formGroup.get('type')?.value;
      return type && type !== 'torso' && type !== 'face';
    }
    return false;
  }

  onFilesDropped(files: any) {
    if (!files || files.length === 0) return;

    for (const item of files) {
      const extension = item.name.split('.').pop().toLowerCase(); // Mejor manera de obtener extensión
      if (extension === 'stl' || extension === 'obj') {
        this.currentUpload.push(item);
      } else {
        this.files.push(item);
      }
    }
  }

  onFileTypeChanged(event: any, fileIndex: number) {
    const newFileType = event.value;
    const requiresLeftOrRightFileTypes = [
      FileTypes.plantarSurface,
      FileTypes.foot,
      FileTypes.foam,
      FileTypes.leg
    ]

    const formArray = this.filesToClassifyForm.get('files') as FormArray;

    if (fileIndex >= 0 && fileIndex < formArray.length) {
      const formGroup = formArray.at(fileIndex) as FormGroup;

      if (requiresLeftOrRightFileTypes.includes(newFileType)) {
        formGroup.get('side')!.addValidators([Validators.required, Validators.minLength(1)]);
      } else {
        formGroup.get('side')!.removeValidators([Validators.required, Validators.minLength(1)]);
        formGroup.get('side')!.setValue('');
      }

    }
  }

  isInvalid(i: number): boolean {
    const formArray = this.filesToClassifyForm.get('files') as FormArray;
    if (i >= 0 && i < formArray.length) {
      const formGroup = formArray.at(i) as FormGroup;
      return formGroup.invalid;
    }
    return true; // Devuelve true si no es un índice válido
  }

  resetForm(): void {
    this.filesToClassifyForm.reset();
    this.currentUpload = [];
    this.files = [];
    this.currentStep = 0;
    this.closeModalWhenCancel.emit();
  }

  submitForm() {
    if (this.filesToClassifyForm.valid) {
      console.log("Classificated formData: ", this.filesToClassifyForm.value)
      this.formDataReady.emit(this.filesToClassifyForm.value); // Emitir el valor del formulario
      this.currentStep = 0
    } else {
      console.error("El formulario es inválido");
    }

    this.closeModalWhenSubmit.emit();
  }
}
